module.exports = __webpack_public_path__ + "img/MobileDefaultFeedbackGood.3494d2c5.png";